import { Link } from "react-router-dom";
import Aza from "../../assets/game.png";
import { useSelector } from "react-redux";

const GameCard = ({ game, auth }) => {
  const language = useSelector((state) => state.lang.language);
  return (
    <div className="bg-white p-2 rounded-2xl flex flex-col items-center  gap-2 justify-between w-full h-full">
      <Link
        to={
          auth?.token
            ? {
                pathname: "/playing",
                search: `?name=${game.name["en"]}&url=${
                  game.gameUrl
                }&with_history=${game.with_history || false}`,
              }
            : "/auth"
        }
        className="flex flex-col space-y-2 text-[#8DC63F]  font-gotham    text-center  uppercase    justify-center items-center w-full pb-2"
      >
        <div className="h-[250px]  w-full overflow-hidden rounded-xl">
          <img
            src={game?.image[0]}
            className="h-full w-full object-cover "
            alt={game.name["en"]}
          />
        </div>

        <h3 className="text-[#8DC63F] text-xl font-semibold">
          {game?.name[language.lang]}
        </h3>
        {/* <p className=" text-[#8DC63F] text-sm capitalize">
          High Score: {game?.highScore ? game.highScore : ""}
        </p> */}
      </Link>
    </div>
  );
};

export default GameCard;
